<template>
  <section>
    <b-card title="">
      <b-row
        xl="12"
        sm="12"
      >
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <v-select
            v-model="project"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="projectList"
            :reduce="(v) => v.value"
            label="title"
            placeholder="Project"
            class="w-100"
          />
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
        >
          <b-input-group>
            <flat-pickr
              v-model="date_start"
              class="form-control"
              :config="config"
              placeholder="DD-MM-YYYY"
              @input="(date) => changeDate(date, 'date_start')"
            />
            <b-input-group-append is-text>
              <feather-icon
                icon="CalendarIcon"
                class="cursor-pointer"
              />
              <b>&nbsp;Start</b>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
        >
          <b-input-group>
            <flat-pickr
              v-model="date_finish"
              class="form-control"
              :config="config"
              placeholder="DD-MM-YYYY"
              @input="(date) => changeDate(date, 'date_finish')"
            />
            <b-input-group-append is-text>
              <feather-icon
                icon="ClockIcon"
                class="cursor-pointer"
              />
              <b>&nbsp;Finish</b>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col>
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            class="sidebar-center"
            variant="outline-primary"
            @click="filterz()"
          >
            <feather-icon icon="SearchIcon" /> Filter
          </b-button>
        </b-col>
        <!--MHD-->
      </b-row>
    </b-card>
    <b-card-code
      no-body
    >
      <div>
        <div class="h-50 d-inline-block" />
      </div>
      <div class="d-none justify-content-between flex-wrap">
        <!-- sorting  -->
        <b-form-group
          label="Sort"
          label-size="sm"
          label-align-sm="left"
          label-cols-sm="3"
          label-for="sortBySelect"
          class="ml-1"
        >
          <b-input-group size="sm">
            <b-form-select
              id="sortBySelect"
              v-model="sortBy"
              :options="sortOptions"
            >
              <template #first>
                <option value="">
                  none
                </option>
              </template>
            </b-form-select>
            <b-form-select
              v-model="sortDesc"
              size="sm"
              :disabled="!sortBy"
            >
              <option :value="false">
                Asc
              </option>
              <option :value="true">
                Desc
              </option>
            </b-form-select>
          </b-input-group>
        </b-form-group>

        <!-- filter -->
        <b-form-group
          label="Filter"
          label-cols-sm="3"
          label-align-sm="left"
          label-size="sm"
          label-for="filterInput"
          class="mr-1"
        >
          <b-input-group size="sm">
            <b-form-input
              id="filterInput"
              v-model="filter"
              type="search"
              placeholder="Type to Search"
              @input="onSearch"
            />
            <b-input-group-append>
              <b-button
                :disabled="!filter"
                @click="filter = ''"
              >
                Clear
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </div>
      <b-table
        striped
        hover
        responsive
        class="position-relative"
        :items="items"
        :fields="fields"
        @sort-changed="sortChanged"
      >
        <template #cell(ph_status)="{ value }">
          <div :class="`text-${value === true ? 'success' : 'danger'}`">
            {{ value === true ? 'Online' : 'Offline' }}
          </div>
        </template> 
        <template #cell(nh3n_status)="{ value }">
          <div :class="`text-${value === true ? 'success' : 'danger'}`">
            {{ value === true ? 'Online' : 'Offline' }}
          </div>
        </template> 
        <template #cell(cod_status)="{ value }">
          <div :class="`text-${value === true ? 'success' : 'danger'}`">
            {{ value === true ? 'Online' : 'Offline' }}
          </div>
        </template> 
        <template #cell(tss_status)="{ value }">
          <div :class="`text-${value === true ? 'success' : 'danger'}`">
            {{ value === true ? 'Online' : 'Offline' }}
          </div>
        </template> 
        <template #cell(flow_status)="{ value }">
          <div :class="`text-${value === true ? 'success' : 'danger'}`">
            {{ value === true ? 'Online' : 'Offline' }}
          </div>
        </template> 
        <template #cell(pln)="{ value }">
          <div :class="`text-${value === true ? 'success' : 'danger'}`">
            {{ value === true ? 'Online' : 'Offline' }}
          </div>
        </template> 
        <template #cell(ups)="{ item }">
          <div :class="`text-${(item.pln === true && item.ups === true) ? 'success' : (item.pln === false && item.ups === true) ? 'warning' : 'danger'}`">
            {{ (item.pln === true && item.ups === true) ? 'On Charge' : (item.pln === false && item.ups === true) ? 'Discharging' : 'Nonactive' }}
          </div>
        </template> 
        <template #cell(ph_alarm)="{ item }">
          <div :class="`text-${item.ph <= 6.5 || item.ph >= 8.5 ? 'warning' : 'success'}`">
            {{ item.ph <= 6.5 || item.ph >= 8.5 ? 'Alarm' : 'Normal' }}
          </div>
        </template> 
        <template #cell(nh3n_alarm)="{ item }">
          <div :class="`text-${item.nh3n <= 0.5 || item.nh3n >= 9.5 ? 'warning' : 'success'}`">
            {{ item.nh3n <= 0.5 || item.nh3n >= 9.5 ? 'Alarm' : 'Normal' }}
          </div>
        </template> 
        <template #cell(cod_alarm)="{ item }">
          <div :class="`text-${item.cod <= 0.5 || item.cod >= 99.5 ? 'warning' : 'success'}`">
            {{ item.cod <= 0.5 || item.cod >= 99.5 ? 'Alarm' : 'Normal' }}
          </div>
        </template> 
        <template #cell(tss_alarm)="{ item }">
          <div :class="`text-${item.tss <= 0.5 || item.tss >= 149.5 ? 'warning' : 'success'}`">
            {{ item.tss <= 0.5 || item.tss >= 149.5 ? 'Alarm' : 'Normal' }}
          </div>
        </template> 
        <template #cell(debit_alarm)="{ item }">
          <div v-if="project === 2">
            <div :class="`text-${item.flow >= 415 ? 'warning' : 'success'}`">
              {{ item.flow >= 415 ? 'Alarm' : 'Normal' }}
            </div>
          </div>
          <div v-if="project === 8">
            <div :class="`text-${item.flow >= 332 ? 'warning' : 'success'}`">
              {{ item.flow >= 332 ? 'Alarm' : 'Normal' }}
            </div>
          </div>
          <div v-if="project === 9 || project === 14">
            <div :class="`text-${item.flow >= 165 ? 'warning' : 'success'}`">
              {{ item.flow >= 165 ? 'Alarm' : 'Normal' }}
            </div>
          </div>
        </template> 
      </b-table>
      <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
        <p class="text-nowrap align-left">
          &nbsp;Total Rows {{ totalRows }}
        </p>
        <b-form-group
          label="Per Page"
          label-cols="6"
          label-align="left"
          label-size="sm"
          label-for="sortBySelect"
          class="text-nowrap mb-md-0 mr-1"
        >
          <b-form-select
            id="perPageSelect"
            v-model="perPage"
            size="sm"
            inline
            :options="pageOptions"
            @change="currentPage = 1; filterz()"
          />
        </b-form-group>
        <p class="text-nowrap mb-md-0 mr-1 align-left" />
        <!-- pagination -->
        <div>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
            class="mb-0"
            @input="filterz"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </div>
      </b-card-body>
    </b-card-code>
  </section>
</template>
<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BTable, BCol, BCard, BRow, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BCardBody, BLink, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import { mapState } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import moment from 'moment'
import flatPickr from 'vue-flatpickr-component'
import project from '@/store/modules/project'
import { getDataItemValue } from 'echarts/lib/util/model'

export default {
  components: {
    flatPickr, BCardCode, vSelect, BTable, BCol, BCard, BRow, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BCardBody, BLink, BDropdown, BDropdownItem,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      date_start: moment(String(new Date())).format('YYYY-MM-DD'),
      date_finish: moment(String(new Date())).format('YYYY-MM-DD'),
      config: {
        enableTime: false,
        time_24hr: false,
      },
      dir: false,
      perPage: 10,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      project: 2,
      filter: null,
      filterOn: [],
      key: 0,
      params: {
        date_start: '',
        date_finish: '',
        project_id: '',
      },
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      status: [{
        AC: 'Active', 2: 'Professional', 3: 'Rejected', 4: 'Resigned', 5: 'Applied',
      },
      {
        AC: 'light-primary', 2: 'light-success', 3: 'light-danger', 4: 'light-warning', 5: 'light-info',
      }],
      reportMHDOption: [
        { title: 'Minutes', value: 'M' },
        { title: 'Hours', value: 'H' },
        { title: 'Days', value: 'D' },
      ],
    }
  },
  computed: {
    ...mapState({
      totalRows: state => state.historicalRawData.reportMHD.totalRows,
      fields: state => state.historicalRawData.reportMHD.fields,
      items: state => state.historicalRawData.reportMHD.items,
      pageOptions: state => state.historicalRawData.reportMHD.pageOptions,
      projectList: state => state.project.options,
    }),
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    dateFormat() {
      // eslint-disable-next-line camelcase
      return create_at => this.$options.filters.formatDate(create_at)
    },
  },
  mounted() {
    // Set the initial number of items
    this.$store.state.totalRows = this.items.length
  },
  created() {
    const dateStart = moment(this.date_start, 'YYYY-MM-DD')
    const dateFinish = dateStart.clone().add(23, 'hours').add(59, 'minutes')
    this.params = {
      date_start: dateStart.utc().toISOString(),
      date_finish: dateFinish.utc().toISOString(),
      project_id: this.project,
      page: this.currentPage,
      limit: this.perPage,
      search: this.filter,
    }
    this.$store.dispatch('historicalRawData/getReportMHD', this.params)
    this.$store.dispatch('project/getAll', { company_id: this.userData.data.company_id })
    this.debouncedSearch = this.debounce(this.filterz, 500)
  },
  methods: {
    sortChanged({ sortBy, sortDesc, sortDirection }) {
      this.sortBy = sortBy
      this.sortDesc = sortDesc
      this.sortDirection = sortDirection
      this.filterz()
    },
    onSearch() {
      this.debouncedSearch(this.filterz)
    },
    debounce(func, wait) {
      let timeout
      return function (...args) {
        clearTimeout(timeout)
        timeout = setTimeout(() => func.apply(this, args), wait)
      }
    },
    changeDate(selectedDate, field) {
      this[field] = selectedDate

      // Return the updated params object
      return {
        [field]: this[field],
      }
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.$store.state.totalRows = filteredItems.length
      this.currentPage = 1
    },
    advanceSearch(val) {
      this.searchTerm = val
    },
    notification(a, b, c, d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title: a, icon: b, variant: c, text: d,
        },
      })
    },
    groupItemsByDate() {
      const groupedItems = {}
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < this.items.length; i++) {
        const date = this.items[i].date_time.split(' ')[0]
        if (!groupedItems[date]) {
          groupedItems[date] = []
        }
        groupedItems[date].push(this.items[i])
      }
      return groupedItems
    },
    filterz() {
      // Use changeDate to update date_start and date_finish fields
      this.changeDate(this.date_start, 'date_start')
      this.changeDate(this.date_finish, 'date_finish')

      const dateStartUTC = moment(this.date_start, 'YYYY-MM-DD').utc().toISOString()
      const dateFinishUTC = moment(this.date_finish, 'YYYY-MM-DD').add(23, 'hours').add(59, 'minutes').utc()
        .toISOString()

      const start = moment(this.date_start)
      const end = moment(this.date_finish)

      const diffInDays = end.diff(start, 'days')

      if (diffInDays > 31) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Warning',
            icon: 'AlertCircleIcon',
            variant: 'error',
            text: 'The selected range cannot exceed 31 days.',
          },
        })
        return
      }

      const orderBy = this.sortBy ? JSON.stringify({ [this.sortBy]: this.sortDesc ? 'desc' : 'asc' }) : ''

      // Update this.params based on the provided fields
      this.params = {
        date_start: dateStartUTC,
        date_finish: dateFinishUTC,
        project_id: this.project,
        page: this.currentPage,
        limit: this.perPage,
        search: this.filter,
      }

      if (orderBy) {
        this.params.orderBy = orderBy
      }

      // Dispatch action with updated params
      this.$store.dispatch('historicalRawData/getReportMHD', this.params)
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
<style lang="scss">
.label-nowrap {
  white-space: nowrap;
}
</style>
